import React, { useState } from "react";
import GridToolbarNoExport from "../../../common/GridToolbarNoExport";
import AppDataGrid from "../../../common/AppDataGrid";
import { CircularProgress, Snackbar, Button } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink, faEdit } from "@fortawesome/free-solid-svg-icons";
import EditForm from "./EditForm"; // Import EditForm component
import * as Icons from "@fortawesome/free-solid-svg-icons"; // Import all FontAwesome icons

const List = ({ resources, loading, fetchResources }) => {
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [selectedResource, setSelectedResource] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const handleEditClick = (resource) => {
    setSelectedResource(resource);
    setEditDialogOpen(true);
  };

  const handleEditDialogClose = () => {
    setEditDialogOpen(false);
    setSelectedResource(null);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleResourceUpdated = () => {
    setSnackbarOpen(true);
    fetchResources(); // Refresh the list
  };

  const columns = [
    { field: "title", headerName: "Title", flex: 1 },
    {
      field: "icon",
      headerName: "Icon",
      flex: 1,
      renderCell: (params) => {
        const iconName = params.row.icon;
        const iconDefinition = Icons[iconName] || Icons.faLink; // Use the icon from Firebase or default to faLink
        return (
          <FontAwesomeIcon
            icon={iconDefinition}
            size="2x"
            style={{ color: params.row.iconColor }}
          />
        );
      },
    },
    {
      field: "link",
      headerName: "Link",
      flex: 1,
      renderCell: (params) => (
        <a href={params.value} target="_blank" rel="noreferrer">
          {params.value}
        </a>
      ),
    },
    {
      field: "edit",
      headerName: "Edit",
      sortable: false,
      filterable: false,
      flex: 1,
      renderCell: (params) => (
        <Button
          variant="outlined"
          color="primary"
          startIcon={<FontAwesomeIcon icon={faEdit} />}
          onClick={() => handleEditClick(params.row)}
        >
          Edit
        </Button>
      ),
    },
  ];

  if (loading) {
    return <CircularProgress />;
  }

  return (
    <div style={{ width: "100%" }}>
      <AppDataGrid
        rows={resources}
        columns={columns}
        pageSize={5}
        slots={{
          toolbar: GridToolbarNoExport,
        }}
      />
      {selectedResource && (
        <EditForm
          open={editDialogOpen}
          onClose={handleEditDialogClose}
          resource={selectedResource}
          onResourceUpdated={handleResourceUpdated}
        />
      )}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        message="Resource has been updated"
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        ContentProps={{
          sx: {
            backgroundColor: "black",
            color: "white",
          },
        }}
      />
    </div>
  );
};

export default List;
